import axios from 'axios';

/**
 * Calendar appointment metrics. Mirrors the calls module: a single `get`
 * action posts to `metrics/appointments` and returns the raw series. The
 * endpoint groups by a time dimension (`group`) and filters by `status`,
 * `user` and `service`. It still expects `startDate`/`endDate` (unlike the
 * contact-center SLA endpoints that moved to `start`/`end`).
 */
const state = {
  data: [],
};

const mutations = {
  data(state, value) {
    state.data = value;
  },
};

const actions = {
  get({ commit }, body) {
    return new Promise((resolve, reject) => {
      axios.post('metrics/appointments', body)
        .then(({ data }) => {
          commit('data', data);
          resolve(data);
        })
        .catch(error => reject(error));
    });
  },
};

const getters = {
  data: state => state.data,
};

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters,
};
